import { render, staticRenderFns } from "./CbsFileEntity.vue?vue&type=template&id=1c202015&scoped=true"
import script from "./CbsFileEntity.vue?vue&type=script&lang=js"
export * from "./CbsFileEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c202015",
  null
  
)

export default component.exports